import api from "../../utilities/api";
export function fetchUsers() {
  // previously: api.get('/users')
  return api.get("/api/user/users").then((res) => res.data.data);
}
export function fetchUsersPaginated(options = {}) {
  const { page = 0, limit = 10, search = "", filters = {}, sort = {} } = options;
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("limit", limit);
  if (search && search.trim()) params.append("search", search.trim());
  if (filters.role) params.append("role", filters.role);
  if (filters.gender) params.append("gender", filters.gender);
  if (typeof filters.verified === "boolean") params.append("verified", String(filters.verified));
  if (typeof filters.hasPhone === "boolean") params.append("hasPhone", String(filters.hasPhone));
  if (typeof filters.hasReferral === "boolean") params.append("hasReferral", String(filters.hasReferral));
  if (filters.hasRegisterIp === "boolean") params.append("hasRegisterIp", String(filters.hasRegisterIp));
  if (filters.authProvider && Array.isArray(filters.authProvider)) filters.authProvider.forEach((p) => params.append("authProvider", p));
  if (filters.country) params.append("country", filters.country);
  if (filters.createdFrom) params.append("createdFrom", filters.createdFrom);
  if (filters.createdTo) params.append("createdTo", filters.createdTo);
  if (filters.updatedFrom) params.append("updatedFrom", filters.updatedFrom);
  if (filters.updatedTo) params.append("updatedTo", filters.updatedTo);
  if (sort.field) params.append("sortField", sort.field);
  if (sort.order) params.append("sortOrder", sort.order);
  return api
    .get(`/api/user/users/paginated?${params.toString()}`)
    .then((res) => res.data.data);
}
export function fetchUsersAnalytics(month = null, year = null) {
  const params = new URLSearchParams();
  if (month !== null) params.append("month", month);
  if (year !== null) params.append("year", year);
  const queryString = params.toString() ? `?${params.toString()}` : '';
  return api.get(`/api/user/users/analytics${queryString}`).then((res) => res.data.data);
}
export function fetchLoginAnalytics(month = null, year = null) {
  const params = new URLSearchParams();
  if (month !== null) params.append("month", month);
  if (year !== null) params.append("year", year);
  const queryString = params.toString() ? `?${params.toString()}` : '';
  return api.get(`/api/user/users-track/analytics${queryString}`).then((res) => res.data.data);
}
export function fetchUserTokens(rowsPerPage = 10) {
  // previously: api.get('/users')
  return api
    .get(`/api/user/users-track?limit=${rowsPerPage}`)
    .then((res) => res.data.data);
}

export function fetchUserTrackSearch(search, filters = {}, rowsPerPage = 100) {
  const params = new URLSearchParams();
  if (search) params.append("query", search);
  if (rowsPerPage) params.append("limit", rowsPerPage);
  if (filters.app) params.append("app", filters.app);
  if (filters.method) params.append("method", filters.method);
  if (filters.location) params.append("location", filters.location);

  return api
    .get(`/api/user/users-track/search?${params.toString()}`)
    .then((res) => res.data.data);
}

export function fetchUserTrackFilters() {
  return api.get("/api/user/users-track/filters").then((res) => res.data.data);
}

export const createUser = (user) =>
  api.post("/users", user).then((res) => res.data);

export const fetchLoginAnalyticsDetails = async (filters) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key] !== undefined && filters[key] !== null) {
      params.append(key, filters[key]);
    }
  });
  return api.get(`/api/user/users-track/analytics/details?${params.toString()}`).then((res) => res.data.data);
};

export const fetchUserAnalyticsDetails = async (filters) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key] !== undefined && filters[key] !== null) {
      params.append(key, filters[key]);
    }
  });
  return api.get(`/api/user/users/analytics/details?${params.toString()}`).then((res) => res.data.data);
};
